import React, {Component} from 'react';
import { Link } from 'react-router-dom';
class Footer extends Component {
    render() {
	    return (
			<footer id="footer" className="footer ">
				<div className="footer-top">
					<div className="container">
						<div className="row">
							<div className="col-lg-3 col-md-6 col-12">
								<div className="single-footer">
									<h2>Get in touch</h2>
									<ul className="time-sidual">
										<li className="day"><b>Address :</b> 1502 Brittain Rd #1058 Akron, OH 44310</li>
										<li className="day"><b>Phone :</b> 866-540-7194</li>
										<li className="day"><b>Email :</b> info@redixpresslogistics.com</li>
										
									</ul>
								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-12">
								<div className="single-footer f-link">
									<h2>Information</h2>
									<ul>
										<li><Link to="/terms"><i className="fa fa-caret-right" aria-hidden="true"></i>Terms & Conditions</Link></li>
										<li><Link to="/privacy"><i className="fa fa-caret-right" aria-hidden="true"></i>Privacy Policy</Link></li>
										<li><a href="#"><i className="fa fa-caret-right" aria-hidden="true"></i>Request A Quote</a></li>
										<li><Link to="/faq"><i className="fa fa-caret-right" aria-hidden="true"></i>FAQ'S</Link></li>
									</ul>
								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-12">
								<div className="single-footer">
									<h2>Newsletter</h2>
									<p>Subscribe to our newsletter and receive the latest tips via email.</p>
									<form action="mail/mail.php" method="get" target="_blank" className="newsletter-inner">
										<input name="email" placeholder="Email Address" className="common-input" 
												required="" type="email" />
										<button className="button"><i className="icofont icofont-paper-plane"></i></button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="copyright">
					<div className="container">
						<div className="row">
							<div className="col-lg-12 col-md-12 col-12">
								<div className="copyright-content">
									<p>© Copyright 2023  |  All Rights Reserved by <a href="#" target="_blank">Redixpress.</a> </p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
	     );
    }
}
export default Footer;